import { put, take, call } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import withLoading from '../../../sagas/loadingSaga';
import {
  getEntityKpiDetailsAction,
  getEntityKpiDetailsError,
  getEntityKpiDetailsSuccess,
} from '../../../reducers/entityKpiDetailsSlice';
import { KpiDetailsInterface } from '../FullKpiGrid/types';

export default function* entityKpiDetailsSaga(api) {
  while (true) {
    const entityKpiDetailsAction: ReturnType<typeof getEntityKpiDetailsAction> =
      yield take(getEntityKpiDetailsAction.type);
    yield* withLoading(function* () {
      const { entityId } = entityKpiDetailsAction.payload;
      yield call(getEntityKpiDetails, api, entityId);
    });
  }
}

function* getEntityKpiDetails(api, entityId) {
  try {
    const entityKpiDetails: AxiosResponse<KpiDetailsInterface[]> = yield call(
      api.getEntityKpiDetails,
      entityId,
    );
    const entityKpiDetailsResponse = entityKpiDetails.data;
    yield put(getEntityKpiDetailsSuccess(entityKpiDetailsResponse));
  } catch (error) {
    yield put(getEntityKpiDetailsError(error as string));
  }
}
